import WorkClient from '../api/workClient';

const getDropPointsByDistance = (latitude: number, longitude: number) => {
  return WorkClient.getDropPointsByDistance(latitude, longitude);
};

const getAllDropPoints = () => {
  return WorkClient.getAllDeliveryDropPoints();
};

const getMainWarehouseInventoryByItems = (goodIds: string[]) => {
  return WorkClient.getMainWarehouseInventoryByItems(goodIds);
};

const canOrderGoods = (projectId: string) => {
  return WorkClient.canOrderGoods(projectId);
}

const canConsumeGoods = (projectId: string) => {
  return WorkClient.canConsumeGoods(projectId);
}

const WarehouseService = {
  getDropPointsByDistance,
  getAllDropPoints,
  getMainWarehouseInventoryByItems,
  canOrderGoods,
  canConsumeGoods
};

export default WarehouseService;
